/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import Analytics from 'packages/analytics';
import getInitialState from './initial-state';

const profileSlice = createSlice({
    name: 'profile',
    initialState: getInitialState(),
    reducers: {
        setTranslatedReviews: (state, { payload }) => {
            state.translatedReviews = [
                ...state.translatedReviews,
                ...payload.items,
            ];
            state.isTranslationOnDemandDisabled = false;
            state.translatedReviewsLoading = false;
            state.translatedReviewsLoadingError = false;
            state.translatedReviewsProviderName = payload.providerName;
        },
        resetTranslatedReview: (state, { payload }) => {
            state.translatedReviews = state.translatedReviews.filter(
                (review) => review.gradeId !== payload.gradeId,
            );
        },
        setTranslationOnDemandIsDisabled: (state) => {
            state.translatedReviews = [];
            state.isTranslationOnDemandDisabled = true;
            state.translatedReviewsLoading = false;
            state.translatedReviewsLoadingError = false;
        },
        showTranslatedReviews: {
            reducer: (state, { payload }) => {
                state.showTranslatedReviews = payload.show;
                state.translatedReviews = state.showTranslatedReviews
                    ? state.translatedReviews
                    : [];
            },
            prepare: (payload) => {
                Analytics.trackEvent({
                    category: 'Profile',
                    action: 'Translation',
                    label: payload.show ? `Show - ${payload.language}` : 'Hide',
                });
                return { payload };
            },
        },
        beginLoadingTranslatedReviews: (state) => {
            state.translatedReviewsLoading = true;
            state.translatedReviewsLoadingError = false;
        },
        failedLoadingTranslatedReviews: (state) => {
            state.translatedReviewsLoading = false;
            state.translatedReviewsLoadingError = true;
        },
        beginLoadingModel: (state) => {
            state.loadingModel = true;
        },
        setModel: (state, { payload }) => {
            state.model = payload.model;
            state.showTranslatedReviews =
                state.showTranslatedReviews &&
                state.translatedReviews.some(
                    ({ gradeId }) =>
                        payload.model.feedbackItems.filter(
                            (feedbackItem) => gradeId === feedbackItem.gradeId,
                        ).length,
                );
            state.loadingModel = false;
        },
        setFeedbackComment: (state, { payload }) => {
            const { feedbackId, comment } = payload;
            const newFeedbackItems = state.model.feedbackItems.map((item) =>
                item.gradeId === feedbackId
                    ? {
                          ...item,
                          hasReply: true,
                          isReplyAllowed: false,
                          reply: comment,
                      }
                    : { ...item },
            );
            state.model.feedbackItems = newFeedbackItems;
        },
    },
});

export const {
    setTranslatedReviews,
    showTranslatedReviews,
    beginLoadingModel,
    beginLoadingTranslatedReviews,
    failedLoadingTranslatedReviews,
    setModel,
    setTranslationOnDemandIsDisabled,
    setFeedbackComment,
    resetTranslatedReview,
} = profileSlice.actions;

export default profileSlice.reducer;
